module.exports = __webpack_public_path__ + "img/Card3.07bcd0a1.jpg";